import { ValueHelpers } from '@headless-workspace/utils';
import { AllStoresStockStatus, WarehouseStockStatus } from '../types';
import { DEFAULT_STORE, DEFAULT_WAREHOUSE } from './DefaultStockInformation';
import { ProductDeliveryAllStoresValue, ProductDeliveryWarehouseValue } from './ProductDeliveryInfoValue';
import { VariantWithStockInformationDTO } from './ProductStockInformationDTO';

export type ProductStockInformationValue = {
    isAvailable: boolean;
    warehouse: ProductDeliveryWarehouseValue;
    store: ProductDeliveryAllStoresValue;
};

const UNAVAILABLE_STOCK_STATUS = 'UNAVAILABLE';

export const mapProductStockInformation = (
    variants: VariantWithStockInformationDTO[],
    sku: string,
): ProductStockInformationValue => {
    const selectedVariant = variants.length > 0 ? variants.find((variant) => variant.id === sku) : undefined;

    if (!selectedVariant) {
        return {
            isAvailable: false,
            warehouse: DEFAULT_WAREHOUSE,
            store: DEFAULT_STORE,
        };
    }

    const warehouseStockStatus = (selectedVariant.stock?.warehouse?.status as WarehouseStockStatus) ?? undefined;

    const warehouse: ProductDeliveryWarehouseValue =
        (warehouseStockStatus && selectedVariant.stock?.warehouse?.deliveryMessage) ||
        warehouseStockStatus === UNAVAILABLE_STOCK_STATUS
            ? {
                  stockStatus: warehouseStockStatus,
                  deliveryDescription: ValueHelpers.mapOptional(selectedVariant.stock?.warehouse?.deliveryMessage),
              }
            : DEFAULT_WAREHOUSE;

    const storeStockStatus = (selectedVariant.stock?.store?.status as AllStoresStockStatus) ?? undefined;

    const store: ProductDeliveryAllStoresValue =
        storeStockStatus && selectedVariant.stock?.store?.deliveryMessage
            ? {
                  stockStatus: storeStockStatus,
                  clickAndCollectTitle: selectedVariant.stock.store.deliveryMessage,
              }
            : DEFAULT_STORE;

    return {
        isAvailable: selectedVariant.isAvailable ?? false,
        warehouse,
        store,
    };
};
